import { createSlice } from '@reduxjs/toolkit';

import type { ContextoAcessoState } from '@/types/contextoAcesso/types';

import { carregarContextos, trocarContexto } from './actions';

const initialState: ContextoAcessoState = {
  contextos: [],
  ultimoContexto: null,
  loading: false,
  error: null,
  trocando: false,
};

const slice = createSlice({
  name: 'contextoAcesso',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(carregarContextos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(carregarContextos.fulfilled, (state, action) => {
        state.loading = false;
        state.contextos = action.payload.contextos;
        state.ultimoContexto = action.payload.ultimoContexto;
      })
      .addCase(carregarContextos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Erro ao carregar seus contextos';
      })
      .addCase(trocarContexto.pending, (state) => {
        state.trocando = true;
        state.error = null;
      })
      .addCase(trocarContexto.fulfilled, (state, action) => {
        state.trocando = false;
        state.ultimoContexto = action.payload;
      })
      .addCase(trocarContexto.rejected, (state, action) => {
        state.trocando = false;
        state.error = action.payload ?? 'Erro ao trocar de contexto';
      });
  },
});

export default slice.reducer;
